import React from 'react';
import { useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { useVociPortale, VOCE_DEL_PATH } from '../utils/vociPortale';

// Pagina di un portale spenta da Impostazioni → Ruoli: al posto del contenuto un avviso.
export default function VocePortale({ children }) {
  const { user } = useAuth();
  const loc = useLocation();
  const voci = useVociPortale();
  const percorso = loc.pathname.replace(/\/$/, '') || '/';
  // sottopagine FIPAV (/cliente/fipav/iscrizioni…) = stessa voce
  const chiave = VOCE_DEL_PATH[percorso] ?? (percorso.startsWith('/cliente/fipav/') ? 'FIPAV' : undefined);
  if (!chiave) return children;
  if (voci.fallito) return children; // stato non leggibile: si mostra, il server blocca comunque le azioni
  if (!voci.pronto) return null;
  if (voci.attiva(chiave, user)) return children;
  return (
    <div style={{ maxWidth: '560px', margin: '40px auto', background: 'var(--bg-card)', border: '1px solid var(--border)', borderRadius: '12px', padding: '24px', color: 'var(--text)' }}>
      <div style={{ fontWeight: 800, fontSize: 'var(--font-size-lg)', marginBottom: '8px' }}>Sezione non disponibile</div>
      <div style={{ color: 'var(--text-muted)', fontSize: 'var(--font-size-sm)' }}>Questa parte del portale al momento non è attiva. Per informazioni contatta la segreteria.</div>
    </div>
  );
}
